export function reloadCheck(Sentry) {
  const clientData = {
    navEntry: "reload",
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    memory: navigator.deviceMemory, // GB, Chrome only
    cores: navigator.hardwareConcurrency,
    language: navigator.language,
    viewport: `${window.innerWidth}x${window.innerHeight}`
  }

  const navEntry = performance.getEntriesByType("navigation")[0]

  if (navEntry?.type === "reload") {
    Sentry.captureException(clientData)
  }
}

export default {
  reloadCheck
}
